import React from "react";
import { Link } from "react-router-dom";
import { BackgroundBeams } from "../ui/background-beams.tsx";

export default function PaymentSuccessPage() {
  return (
    <div className="relative w-full min-h-screen bg-black text-white flex flex-col items-center justify-center px-4 py-12">
      <BackgroundBeams />

      {/* Inline styles for the SVG animation */}
      <style>{`
        @keyframes draw-circle {
          from { stroke-dashoffset: 300; }
          to   { stroke-dashoffset: 0; }
        }
        @keyframes draw-check {
          from { stroke-dashoffset: 120; }
          to   { stroke-dashoffset: 0; }
        }

        .animate-draw-circle {
          stroke-dasharray: 300;
          stroke-dashoffset: 300;
          animation: draw-circle 0.8s ease-out forwards;
        }
        .animate-draw-check {
          stroke-dasharray: 120;
          stroke-dashoffset: 120;
          animation: draw-check 0.6s ease-out 0.3s forwards;
        }

        /* Respect users who prefer reduced motion */
        @media (prefers-reduced-motion: reduce) {
          .animate-draw-circle,
          .animate-draw-check {
            animation: none;
            stroke-dashoffset: 0;
          }
        }
      `}</style>

      {/* Success Box / Card */}
      <div className="relative z-10 max-w-md w-full bg-gray-900/90 border border-gray-700 rounded-xl shadow-lg p-8 text-center backdrop-blur">
        {/* Animated SVG Check */}
        <svg viewBox="0 0 100 100" className="mx-auto h-20 w-20">
          {/* Circle (drawn first) */}
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="none"
            stroke="#22c55e" /* Tailwind green-500 */
            strokeWidth="4"
            className="animate-draw-circle"
          />
          {/* Checkmark (drawn second) */}
          <polyline
            points="30,55 45,70 70,35"
            fill="none"
            stroke="#22c55e"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="animate-draw-check"
          />
        </svg>

        <h1 className="mt-6 text-3xl font-bold">Payment Accepted</h1>
        <p className="mt-4 text-lg text-gray-300">
          Thank you! Your payment went through successfully.
        </p>

        {/* Single blue button */}
        <div className="mt-8">
          <Link to="/datanomad">
            <button className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg">
              Back to Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
